import { render, staticRenderFns } from "./ProfilePurse.vue?vue&type=template&id=19d2662a&"
import script from "./ProfilePurse.js?vue&type=script&lang=js&"
export * from "./ProfilePurse.js?vue&type=script&lang=js&"
import style0 from "./ProfilePurse.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports